import { DiaryEntry, IDictionary } from "shared/types";

export const dictMap = (lastEntries: DiaryEntry[]) => {
  const map = new Map<string, { dict: IDictionary; hiveIds: Set<string> }>();

  for (const entry of lastEntries) {
    const hiveId = entry.hive?.id;
    if (hiveId == null) continue;

    const hiveIdStr = String(hiveId);

    (entry.dictionaries ?? []).forEach((d) => {
      if (!d.id) return;

      const dictId = String(d.id);
      const existing = map.get(dictId);

      if (existing) {
        existing.hiveIds.add(hiveIdStr);
      } else {
        map.set(dictId, { dict: d, hiveIds: new Set([hiveIdStr]) });
      }
    });
  }

  const allDictionaries: IDictionary[] = Array.from(map.values()).map(
    (v) => v.dict
  );

  const hivesCount = new Set(lastEntries.map((e) => String(e.hive?.id))).size;

  const commonDictionaryIds = Array.from(map.entries())
    .filter(([_, v]) => v.hiveIds.size === hivesCount)
    .map(([id, { dict }]) => {
      return {
        key: id,
        value: dict.name,
      };
    });

  return { allDictionaries, commonDictionaryIds };
};
